<div
  class="panel"
  fxLayout="row wrap"
  fxLayoutAlign="start stretch"
  style.margin-left="{{ -xOffset }}px"
  style.margin-top="{{ -yOffset }}px"
>
  <ng-container *ngFor="let item of items">
    <div
      *ngIf="item.fbWrapPanelItemVisibility !== 'none'"
      class="cell"
      [class.hide]="item.fbWrapPanelItemVisibility === 'hide'"
      [class.opacity-zero]="item.fbWrapPanelItemVisibility === 'opacity-zero'"
      [fxFlex.lg]="item.fbWrapPanelItem | wrapPanelWidth : 'lg'"
      [fxFlex]="item.fbWrapPanelItem | wrapPanelWidth : 'md'"
      [fxFlex.sm]="item.fbWrapPanelItem | wrapPanelWidth : 'sm'"
      [fxFlex.xs]="item.fbWrapPanelItem | wrapPanelWidth : 'xs'"
      style.padding-left="{{ xOffset }}px"
      style.padding-top="{{ yOffset }}px"
    >
      <ng-container [ngTemplateOutlet]="item.templateRef"></ng-container>
    </div>
  </ng-container>
</div>
